import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography, Link } from '@mui/material';
import PlaceIcon from '@mui/icons-material/PlaceOutlined';

import MessageBox from '@ui-lib/components/MessageBox';
import { MESSAGE_SEVERITY } from '@ui-lib/components/MessageBox/const';
import { createSx } from '@ui-lib/utils';

interface Props {
  refetch: () => void;
}

const sx = createSx({
  root: {
    height: '100%',
    width: '100%',
    backgroundColor: 'background.paper',
  },
  content: {
    height: '100%',
    m: 'auto',
    p: 3,
    maxWidth: 600,
    width: '100%',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
  },
  icon: {
    backgroundColor: 'primary.container',
    borderRadius: '50%',
    p: 2,
  },
  fullWidth: {
    width: '100%',
  },
});

export const GeolocationErrorPage = ({ refetch }: Props) => {
  const { t } = useTranslation();
  return (
    <Box sx={sx.root}>
      <Stack spacing={2} sx={sx.content}>
        <PlaceIcon color='primary' fontSize='large' sx={sx.icon} />
        <Typography variant='h6' textAlign='center'>
          {t('geolocationError_title')}
        </Typography>
        <Typography variant='body1' textAlign='center'>
          {t('geolocationError_description')}
        </Typography>
        <Box sx={sx.fullWidth}>
          <MessageBox
            testID='geolocation-error'
            severity={MESSAGE_SEVERITY.ERROR}
            title={t('geolocationError_messageBoxTitle')}
            message={t('geolocationError_messageBoxDescription')}
            footerAction={<Link onClick={refetch}>{t('tryAgain_button')}</Link>}
          />
        </Box>
      </Stack>
    </Box>
  );
};
